// version a

// page section
$(document).ready(function() {
    var movementStrength = 20;
    var height = movementStrength / $(window).height();
    var width = movementStrength / $(window).width();
    $('.page-section').mousemove(function(e) {
        var pageX = e.pageX - ($(window).width() / 2);
        var pageY = e.pageY - ($(window).height() / 2);
        var newvalueX = width * pageX * -1 - 25;
        var newvalueY = height * pageY * -1 - 50;
        $('.page-section').css("background-position", newvalueX + "px     " + newvalueY + "px");
    });
});


// navigation section
$(document).ready(function() {
    var movementStrength = 20;
    var height = movementStrength / $(window).height();
    var width = movementStrength / $(window).width();
    $('.desktop-navigation').mousemove(function(e) {
        var pageX = e.pageX - ($(window).width() / 2);
        var pageY = e.pageY - ($(window).height() / 2);
        var newvalueX = width * pageX * -1 - 25;
        var newvalueY = height * pageY * -1 - 50;
        $('.desktop-navigation').css("background-position", newvalueX + "px     " + newvalueY + "px");
    });
});


// version b
// $('.page-section').mousemove(function(e) {
//     var amountMovedX = (e.pageX * -1 / 30);
//     var amountMovedY = (e.pageY * -1 / 30);
//     $(this).css('background-position', amountMovedX + 'px ' + amountMovedY + 'px');
// });



// WEBPACK FOOTER //
// ./assets/js/features/movingBackground.js